// extracted by mini-css-extract-plugin
export default {"FlagDanger":"flag_FlagDanger__iQIYp","FlagNormal":"flag_FlagNormal__PaWhB"};